import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'TrialFundWaitingTitle',
  props: {
    /** 覆盖默认文案（默认走 trialFund.simStatusPending，已全语言） */
    text: {
      type: String,
      default: ''
    },
    /** 附加 class（定位由父级控制） */
    rootClass: {
      type: [String, Array, Object],
      default: ''
    },
    style: {
      type: Object,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const {
      t,
      locale
    } = useI18n();
    const rootRef = ref(null);
    /** 单行宽度 ≤ 屏宽 80% 才 nowrap */
    const allowNowrap = ref(false);
    const displayText = computed(() => {
      const raw = String(props.text || '').trim();
      return raw || t('trialFund.simStatusPending');
    });

    /** CJK 短标题用大字；拉丁/长文案略收 */
    const isCompactLocale = computed(() => {
      const code = String(locale.value || '').toLowerCase();
      return !/^(zh|ja|ko|th)/.test(code);
    });
    function screenLimitPx() {
      if (typeof window === 'undefined') return 300;
      return window.innerWidth * 0.8;
    }
    async function updateNowrap() {
      // 先按 nowrap（含 compact 字号）渲染，再与屏宽 80% 比较
      allowNowrap.value = true;
      await nextTick();
      const el = rootRef.value;
      if (!el) {
        allowNowrap.value = false;
        return;
      }
      allowNowrap.value = el.scrollWidth <= screenLimitPx() + 1;
    }
    let resizeTimer = null;
    function onResize() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        resizeTimer = null;
        void updateNowrap();
      }, 80);
    }
    watch([displayText, isCompactLocale, () => props.style], () => {
      void updateNowrap();
    });
    onMounted(() => {
      void updateNowrap();
      window.addEventListener('resize', onResize);
      window.addEventListener('orientationchange', onResize);
    });
    onUnmounted(() => {
      if (resizeTimer) clearTimeout(resizeTimer);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("p", {
        ref_key: "rootRef",
        ref: rootRef,
        class: _normalizeClass(["trial-fund-waiting-title", [{
          'is-compact': isCompactLocale.value,
          'is-nowrap': allowNowrap.value
        }, __props.rootClass]]),
        style: _normalizeStyle(__props.style),
        "aria-hidden": "true"
      }, _toDisplayString(displayText.value), 7);
    };
  }
};